import React from 'react';

const formatCurrency = (amount = 0) =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(amount) || 0);

function SaleDisplay({ saleData, storeInfo }) {
  const storeName = storeInfo?.companyName || storeInfo?.storeName || 'Our Store';

  if (!saleData || !Array.isArray(saleData.items) || saleData.items.length === 0) {
    return (
      <div className="cfd-shell cfd-idle-simple">
        <div>
          <p className="cfd-store">{storeName}</p>
          <p className="cfd-pill">Waiting for items…</p>
        </div>
      </div>
    );
  }

  const items = saleData.items;
  const total = Number(saleData.total ?? saleData.finalAmount ?? saleData.amountDue ?? 0);
  const itemCount = items.reduce((sum, item) => sum + (item.quantity || 0), 0);
  const displayItems = [...items].reverse();

  return (
    <div className="cfd-shell">
      <header className="cfd-simple-header">
        <div>
          <p className="cfd-store">{storeName}</p>
          <p className="cfd-pill">{itemCount} item{itemCount === 1 ? '' : 's'}</p>
        </div>
        <div className="cfd-total-only">
          <span>Total</span>
          <strong>{formatCurrency(total)}</strong>
        </div>
      </header>

      <ul className="cfd-simple-list">
        {displayItems.map((item, index) => (
          <li key={getSaleDisplayItemKey(item, index)} className="cfd-simple-line">
            <div>
              <p className="cfd-line-name">{item.name}</p>
              <p className="cfd-line-meta">
                x{item.quantity} · {formatCurrency(item.price)}
              </p>
            </div>
            <span className="cfd-line-total">
              {formatCurrency((item.price || 0) * (item.quantity || 0))}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export const getSaleDisplayItemKey = (item, index) =>
  item?.lineId || item?.displayLineId || item?.productId || item?.product || item?._id || `${item?.name || 'item'}-${index}`;

export default SaleDisplay;
